export function isPdfFile(mimeType: string | null, fileName?: string): boolean {
  return fileTypeLabel(mimeType, fileName) === "PDF";
}

export function fileTypeLabel(
  mimeType: string | null,
  fileName?: string,
  ingestSource?: string | null,
): string {
  if (ingestSource === "CLIPBOARD") {
    return "Заметка";
  }
  if (ingestSource === "MESSENGER") {
    return "Мессенджер";
  }
  if (ingestSource === "SOURCE") {
    return "Источник";
  }
  const name = fileName?.toLowerCase() ?? "";
  const mime = mimeType?.toLowerCase() ?? "";
  if (mime.includes("pdf") || name.endsWith(".pdf")) return "PDF";
  if (mime.includes("wordprocessingml") || name.endsWith(".docx")) return "DOCX";
  if (mime.includes("markdown") || name.endsWith(".md")) return "MD";
  if (mime.startsWith("text/") || name.endsWith(".txt")) return "TXT";
  return "Файл";
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} Б`;
  }
  if (bytes < 1024 * 1024) {
    return `${Math.round(bytes / 1024)} КБ`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} МБ`;
}

export function formatShortDate(value: Date, timeZone?: string): string {
  return new Intl.DateTimeFormat("ru-RU", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone,
  }).format(value);
}

export function formatDateTime(value: Date, timeZone?: string): string {
  return new Intl.DateTimeFormat("ru-RU", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone,
  }).format(value);
}

/** Wall-clock duration for index stage table (completed or live elapsed). */
export function formatElapsedMs(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) {
    return "—";
  }
  const totalSec = Math.max(1, Math.round(ms / 1000));
  if (totalSec < 60) {
    return `${totalSec} с`;
  }
  const totalMin = Math.floor(totalSec / 60);
  const sec = totalSec % 60;
  if (totalMin < 60) {
    return sec === 0 ? `${totalMin} мин` : `${totalMin} мин ${sec} с`;
  }
  const hours = Math.floor(totalMin / 60);
  const min = totalMin % 60;
  return min === 0 ? `${hours} ч` : `${hours} ч ${min} мин`;
}

export function hourInTimeZone(value: Date, timeZone: string): number {
  const hour = new Intl.DateTimeFormat("en-US", {
    timeZone,
    hour: "numeric",
    hourCycle: "h23",
  }).formatToParts(value)
    .find((part) => part.type === "hour")?.value;
  return Number.parseInt(hour ?? "0", 10);
}
